import api from "../../config/client.axios.api";

export const createTypeTransactionApi = async (infoCreate: any) => {
  const response = await api.post(`/type-transaction`, infoCreate);
  return response.data;
};
